import React, { useRef } from 'react'
import Row from 'react-bootstrap/Row'
import Col from 'react-bootstrap/Col'
import {
  InputDateComponent,
  InputTextAreaComponent,
  InputTextComponent,
  SelectComponent
} from 'recupero-comunes'
import InputText from '../../../utils/inputText'
import { Card } from 'react-bootstrap'
import { prettifyRut } from 'react-rut-formatter'

const FormThirdInvolved = ({ data, form, initialValues, row }) => {
  const selects = ['cbSure', 'cbCompany', 'cbCarType', 'cbBrand']

  const refs = useRef(selects.map(() => React.createRef()))

  return (
    <div>
      <Card.Header
        className='d-flex  flex-column align-items-center justify-content-center h-100'
        style={{ background: 'gray', color: 'white' }}
      >
        {form?.formLabel['gestcasos-editimpl-title-terimplicado']}(
        {data?.implicatedDetail[0]?.IdImplicado})
      </Card.Header>
      <Row className='mt-1'>
        <Col md='3'>
          <div className='col'>
            <dt className='text-sm font-large text-gray-500'>
              {form?.formLabel['gestcasos-editimpl-terimplrut']}
            </dt>
            <dd className='mt-1 text-sm text-gray-900 ml-5'>
              {prettifyRut(initialValues.implicado.rut)}
            </dd>
          </div>
        </Col>
        <Col md='3'>
          <div className='col'>
            <dt className='text-sm font-medium text-gray-500'>
              {form?.formLabel['gestcasos-editimpl-terimplnombre']}
            </dt>
            <dd className='mt-1 text-sm text-gray-900 ml-5'>
              {data?.implicatedDetail[0]?.NombreInvolucrado}
            </dd>
          </div>
        </Col>
        <Col md='3'>
          <div className='col'>
            <dt className='text-sm font-medium text-gray-500'>
              {form?.formLabel['gestcasos-editimpl-terimplgestaplic']}
            </dt>
            <dd className='mt-1 text-sm text-gray-900 ml-5'>
              {row.TipoGestion}
            </dd>
          </div>
        </Col>
        <Col md='3'>
          <div className='col'>
            <dt className='text-sm font-medium text-gray-500'>
              {form?.formLabel['gestcasos-editimpl-terimplestado']}
            </dt>
            <dd className='mt-1 text-sm text-gray-900 ml-5'>
              {data?.implicatedDetail[0]?.EstadoImplicado}
            </dd>
          </div>
        </Col>
      </Row>
      <Row className='mt-1'>
        <Col md='3'>
          {data?.cbSure?.length > 0 ? (
            <SelectComponent
              ref={refs.current[selects.indexOf('cbSure')]}
              name='terceroImplicado.seguro'
              label={form?.formLabel['gestcasos-editimpl-terimplseguro']}
              defaultInputValue={
                data.cbSure.find((item) => item.id === row.IdSeguroImplicado)
                  ?.nombre
              }
              labelKey='nombre'
              options={data.cbSure ? data.cbSure : []}
            />
          ) : null}
        </Col>
        <Col md='3'>
          {data?.cbCompany?.length > 0 ? (
            <SelectComponent
              ref={refs.current[selects.indexOf('cbCompany')]}
              name='terceroImplicado.idCompania'
              label={form?.formLabel['gestcasos-editimpl-terimplcia']}
              defaultInputValue={
                data.cbCompany.find((item) => item.id === row.IdCiaImplicado)
                  ?.nombre
              }
              labelKey='nombre'
              options={data.cbCompany ? data.cbCompany : []}
            />
          ) : null}
        </Col>
        <Col md='3'>
          <InputTextComponent
            name='terceroImplicado.idSiniestroIM'
            type='text'
            label={form?.formLabel['gestcasos-editimpl-terimplsinciaimpl']}
          />
        </Col>

        <Col md='3'>
          <InputDateComponent
            name='terceroImplicado.fechaSiniestroIM'
            label={form?.formLabel['gestcasos-lbl-fechasiniestro']}
          />
        </Col>
      </Row>
      <Row className='mt-1'>
        <Col md='3'>
          {data.cbCarType.length > 0 ? (
            <SelectComponent
              ref={refs.current[selects.indexOf('cbCarType')]}
              name='terceroImplicado.tipoVehiculo'
              label={form?.formLabel['gestcasos-editimpl-terimpltipovh']}
              defaultInputValue={
                data.cbCarType.find((item) => item.id === row.IdTipoVehiculo)
                  ?.nombre
              }
              labelKey='nombre'
              options={data.cbCarType ? data.cbCarType : []}
            />
          ) : null}
        </Col>
        <Col md='3'>
          <InputText
            name='terceroImplicado.patente'
            type='text'
            label={form?.formLabel['gestcasos-editimpl-terimplpatente']}
          />
        </Col>
        <Col md='3'>
          {data.cbBrand.length > 0 ? (
            <SelectComponent
              ref={refs.current[selects.indexOf('cbBrand')]}
              name='terceroImplicado.marcaVehiculo'
              label={form?.formLabel['gestcasos-editimpl-terimplmarca']}
              defaultInputValue={
                data.cbBrand.find(
                  (item) => item.id === data?.implicatedDetail[0]?.IdMarca
                )?.nombre
              }
              labelKey='nombre'
              options={data.cbBrand ? data.cbBrand : []}
            />
          ) : null}
        </Col>
        <Col md='3'>
          <InputTextAreaComponent
            name='terceroImplicado.detalleDescripcion'
            type='text'
            label={form?.formLabel['gestcasos-editimpl-terimpldesc']}
          />
        </Col>
      </Row>
    </div>
  )
}

export default FormThirdInvolved
